interface MenuFilterProps {
  activeFilter: string;
  onChange: (filter: string) => void;
}

const filters = [
  { id: 'all', label: 'All Items', icon: 'ri-restaurant-2-line' },
  { id: 'vegetarian', label: 'Vegetarian', icon: 'ri-leaf-line' },
  { id: 'non-veg', label: 'Non-Veg', icon: 'ri-knife-line' },
  { id: 'vegan', label: 'Vegan', icon: 'ri-plant-line' },
  { id: 'spicy', label: 'Spicy', icon: 'ri-fire-line' },
];

export default function MenuFilter({ activeFilter, onChange }: MenuFilterProps) {
  return (
    <div className="sticky top-[60px] z-40 bg-cream/95 backdrop-blur-sm border-b border-charcoal/5 py-4">
      <div className="max-w-7xl mx-auto px-6 flex items-center gap-3 overflow-x-auto scrollbar-hide">
        {filters.map((f) => (
          <button
            key={f.id}
            onClick={() => onChange(f.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-full font-sans text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
              activeFilter === f.id
                ? 'bg-saffron text-white'
                : 'bg-white text-charcoal/70 hover:bg-saffron/10 hover:text-saffron border border-charcoal/10'
            }`}
          >
            <i className={f.icon}></i>
            {f.label}
          </button>
        ))}
      </div>
    </div>
  );
}
